export enum CardSportEnum {
  Top = 0, // 顶部模式
  Spin = 1, // 抽奖模式 最后处于底部
  Still = 2, // 底部静止模式 初始化时使用
  Down = 3, // 统一下落模式 初始化initArr使用
  Win = 4, //
  Add = 5,
}

export enum CardType {
  InitGuide = 'initGuide',
  Init = 'init',
  Result = 'result',
  Win = 'win',
  AddCard = 'addcard', // 补牌
  HoldSpinInit = 'holdspininit', // 补牌
  HoldSpinResult = 'holdspinresult', // 高亮牌
  HoldSpinResultLight = 'holdspinresultLight', // 高亮牌
}

export enum subPageName {
  排行榜 = 'RankModal',
  规则页 = 'RuleModal',
  记录页 = 'RecordModal',
}

export enum WildStateStatus {
  普通 = 0,
  wild形态1 = 1,
  wild形态2 = 2,
}

export enum BoardCardEnum {
  empty = 0,
  ten = 1,
  J = 2,
  Q = 3,
  K = 4,
  A = 5,
  Pian = 6,
  Hua = 7,
  Hong = 8,
  Hei = 9,
  Wild = 10,
  MiniJackPot = 101,
  MajorJackPot = 102,
  GrandJackPot = 103,
  // Scatter
  Scatter = 1001,
}

export interface RoyalWildElement {
  id: number // 元素id
  icon: string // 图标URL
  match_odds: Array<number> // 组合倍率, 长度为5的number数组
}

export interface BoardItem {
  id: BoardCardEnum // 基础卡片id
  wild_state: WildStateStatus // wild形态 0: 普通 1: wild形态1 2: wild形态2
  scatter_value: number // scatte 倍数
}

export interface RoyalWildHoldSpinInfo {
  countdown: number // 倒计时
  hold_spin_id: number // 固定spin id
  bet: number // 下注金额
  spins: number // 剩余spin次数
  board: Array<Array<BoardItem>> // 棋盘
  hold_coords: Array<Array<number>> // 固定的坐标
}

export interface RoyalWildTumble {
  step: number
  combo: number
  combo_multiplier_no: number
  multiplier: number
  win_amount: number // scatter 赢取金额
  winning_coords: Array<Array<number>> // 固定的坐标
  wild_transforms: Array<Array<number>> // 翻转的坐标
  new_board: Array<Array<BoardItem>> // 棋盘
}

export interface RoyalWildHoldSpinTumble {
  step: number
  spins: number
  hold_coords: Array<Array<number>> // 固定的坐标
  new_board: Array<Array<BoardItem>> // 棋盘
}

export interface RoyalWildJackpot {
  winning_coords: Array<Array<number>> // 固定的坐标
  win_amount: number
}

// 新手任务相关
interface RoyalWildNewerTaskInfo {
  task_id: number // 任务id
  status: number // 任务状态:0:未完成;1:已完成;2:已领取
  desc: string // 任务描述
  type: number // 任务类型:1:每日任务;2:总任务
  target: number // 任务目标
  progress: number // 任务进度
  reward_points: number // 任务奖励
}
interface RoyalWildNewerRewardInfo {
  icon: string // 奖励图标
  name: string // 奖励名称
  count: number // 奖励数量
}
interface RoyalWildNewerTaskStage {
  stage_no: number // 任务阶段
  status: number // 阶段状态:0:未完成;1:已完成;2:已领取
  target: number // 阶段需要的点数
  reward: RoyalWildNewerRewardInfo // 阶段奖励
}
export interface RoyalWildNewerTask {
  status?: number // 是否展示任务入口：0-不展示 1-展示
  is_red?: boolean // 是否红点
  countdown: number // 倒计时
  daily_countdown: number // 每日倒计时
  task_list: RoyalWildNewerTaskInfo[] // 任务列表
  main_stages: RoyalWildNewerTaskStage[] // 任务阶段
  total_points: number // 累计点数
  daily_red?: boolean
  total_red?: boolean
}

// 中奖类型枚举
export enum WinTypeEnum {
  NONE = 0,
  SMALL = 1, // small
  BIG = 2, // big
  HUGE = 3, // huge
  EPIC = 4, // epic
  SUPER = 5, // super
  MASSIVE = 6, // massive
  ULTIMATE = 7, // ultimate
  MiniJackPot = 101,
  MajorJackPot = 102,
  GrandJackPot = 103,
}
export interface FreePlayInfo {
  amount: number // 金额
  num: number // 免费次数
}

export interface RoyalWildTop {
  id: number // 用户id
  name: string // 用户名
  zy_id?: string
  avatar: string // 头像
  score: number // 赢钱
  reward: number // 奖励
}

// 1.正常模式 2.滚动模式 3.奖励 4.补牌 。。。。。。。
export enum ProcessStatusEnum {
  init = 0, // 初始化
  normal = 1, // 正常
  scroll = 2, // 滚动
  win = 3, // 开奖
  add_card = 4, // 补牌
  show_comb = 5, // 展示comb
  show_reward = 6, // 展示奖励弹窗
  hold_spin_init = 7, // hold_spin 初始
  hold_spin = 8, // hold_spin 正常
  hold_spin_scroll = 9, // hold_spin 滚动
  hold_spin_reward = 10, // hold_spin 开奖
}

// 历史记录相关
export interface TumbleType {
  step: number // 步骤. 1,2,…
  combo: number // base game 连击次数. 第一次中奖为1，第二次中奖为2，以此类推，未中奖置0
  hold_spin_no: number // hold&spin 的 spin 序号
  winning_coords: Array<Array<number>> // 中奖坐标
  board: Array<Array<BoardItem>> // 新棋盘, 4x5 的 RoyalWildCard 数组
}

// 导量入口
export interface GuideEntry {
  pop_type: number //	0 不展示, 1 中/高bet, 2 普通用户
  free_play_num: number //	赠送freeplay数量
  free_play_amount: number //	赠送freeplay金额
}

export enum SoltMachineStatus {
  hide = 0, // 隐藏
  run = 1, // 出现
  cancel = 2, // 消失
}

export interface RoyalWildJackpotPool {
  bet_amount: number
  grand_jackpot: number // 奖池1
  major_jackpot: number // 奖池2
  mini_jackpot: number // 奖池3
}

export enum BtnType {
  spin = 1,
  freespin = 2,
  freeplay = 3,
  stop = 4,
  freecard = 5,
}
